<template>
    <div>
    <label class="switch">
        <input type="checkbox">
        <span class="slider round"></span>
    </label>
    </div>
</template>

<script>
export default {
    name: 'SwitchForm'
}
</script>

<style lang="sass">
.switch
    position: relative
    display: inline-block
    width: 50px
    height: 20px

.switch input
    width: 0
    height: 0

/* The slider */
.slider 
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;


.slider:before 
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;


input:checked + .slider 
    background-color: $secondary;


input:focus + .slider 
    box-shadow: 0 0 1px $secondary;


input:checked + .slider:before 
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);


/* Rounded sliders */
.slider.round 
    border-radius: 20px;

.slider.round:before 
    border-radius: 50%;

</style>


